export default __webpack_public_path__ + "static/media/banners_moto_madres_1_330x330.850f25ee.png";